import api from './api'
import EP from './endpoints'

export function createSchoolDetail(id, data) {
  return api.post(EP.PARTICIPANT_ADD_SCHOOL(id), data)
}
